export default "__VITE_ASSET__35698fd4__"